import { gridStringOrNumberComparator } from '@mui/x-data-grid';
export * from './cellFormatters';
export * from './styles';
export const defaultPartialDataGridProps = {
    density: 'compact',
    getRowClassName: (params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
    autoPageSize: true,
    columnHeaderHeight: 40,
    rowHeight: 40,
};
/**
 * For use with column definitions that are of `type: string` or `type: singleSelect`
 *
 * {@link https://mui.com/x/react-data-grid/sorting/#custom-comparator}
 */
export const numericAwareStringSortComparator = (a, b, paramsA, paramsB) => {
    if (typeof a === 'string' && typeof b === 'string')
        return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    return gridStringOrNumberComparator(a, b, paramsA, paramsB);
};
